import React from "react"
import _ from 'lodash'
import { compose } from "redux"

import WithHOC from "./action"
import CoreRenderFunction from "DisplayCore"
import { ForgotPasswordLayout } from "PageLayout/ForgotPassword"
import WithCountryHOC from "./country"

const ForgotPassword = props => {

  const hideComponent = ( actionKey ) => {
    switch( actionKey ){
      case 'isPasswordResetPage':
        return !_.isEmpty( props.token )
      default:
        return
    }
  }

  return (
    <CoreRenderFunction 
      { ...props } 
      item={ ForgotPasswordLayout }
      hideComponent={ hideComponent }/>
  )
}

export default compose(
  WithHOC,
  WithCountryHOC
)( ForgotPassword )
